module.exports = __webpack_public_path__ + "static/noah-6c1f4f15fbf7e8707b87b186b2ae81db.png";